import emojiData from "./emoji.json";

export const emojiMap = {};

emojiData.forEach((e) => {
    emojiMap[e.short_name] = {
        x: e.sheet_x,
        y: e.sheet_y,
        category: e.category,
        subcategory: e.subcategory,
        name: e.name,
        unified: e.unified
    };
});
